// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface GenderTransgenderIconSignature {
  Element: SVGSVGElement;
}

export const GenderTransgenderIcon: TOC<GenderTransgenderIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 3V1H20V8H18V4.414L14.885 7.529C15.584 8.51 16 9.706 16 11C16 13.968 13.835 16.4388 11.001 16.9165V19H13.001V21H11.001V23H9.001V21H7.001V19H9.001V16.9169C6.16599 16.44 4 13.9687 4 11C4 7.691 6.691 5 10 5C11.294 5 12.49 5.416 13.471 6.115L16.586 3H13ZM10 15C7.794 15 6 13.206 6 11C6 8.795 7.794 7 10 7C12.206 7 14 8.795 14 11C14 13.206 12.206 15 10 15Z"/>
</svg>
</template>;